
export default {
  name: 'ImportButton',
  props: {
    templates: { type: Array, required: true } // [{value,label,desc}]
  },
  data () {
    return {
      show: false,
      step: 1,
      selectedTemplate: '',
      uploading: false,
      importing: false,
      preview: null,
      result: null,
      rawFile: null,     // 原始 File 对象，用于本地解析全部行
      fullRows: []       // 完整行数据（非仅预览前20行）
    }
  },
  methods: {
    open () { this.show = true; this.step = 1; this.selectedTemplate = ''; this.preview = null; this.result = null },
    close () { this.show = false; this.$emit('done') },
    async downloadTemplate () {
      if (!this.selectedTemplate) return
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/export/template/${this.selectedTemplate}`, {
          headers: { Authorization: `Bearer ${token}` }, responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a'); a.href = url; a.download = `Plato_${this.selectedTemplate}_Import.xlsx`
        document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url)
      } catch (err) { alert('下载模板失败') }
    },
    async onFileChange (e) {
      const file = e.target.files[0]
      if (!file) return
      this.rawFile = file
      this.fullRows = []
      this.uploading = true
      try {
        const token = localStorage.getItem('token')
        const fd = new FormData(); fd.append('file', file)
        const res = await this.axios.post(`/import/${this.selectedTemplate}/preview`, fd, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        })
        this.preview = res.data.data
        // 本地解析全部行（避免 preview 仅返回前 20 行的数据丢失）
        await this.parseAllRows(file)
      } catch (err) {
        alert('解析失败: ' + (err.response?.data?.message || err.message))
      } finally { this.uploading = false }
    },
    async doConfirm () {
      if (!this.preview || this.importing) return
      this.importing = true
      try {
        const token = localStorage.getItem('token')
        // 发送全部行（fullRows），不再仅发送 preview 前 20 行
        const rows = this.fullRows.length > 0 ? this.fullRows : this.preview.preview
        const res = await this.axios.post(`/import/${this.selectedTemplate}/confirm`, {
          rows
        }, { headers: { Authorization: `Bearer ${token}` } })
        this.result = res.data.data
        this.step = 3
      } catch (err) {
        alert('导入失败: ' + (err.response?.data?.message || err.message))
      } finally { this.importing = false }
    },
    // 本地解析全部数据行（避免仅依赖服务端 preview 前 20 行）
    async parseAllRows (file) {
      const isCSV = file.name.toLowerCase().endsWith('.csv')
      try {
        const text = await this.readFileAsText(file)
        if (isCSV) {
          this.fullRows = this.parseCSVRows(text)
        } else {
          // XLSX: 从服务端 preview 响应中取 allRows（服务端 ExcelJS 已解析全部行）
          if (this.preview?.allRows) {
            this.fullRows = this.preview.allRows
          }
        }
      } catch (e) {
        console.warn('[Import] 本地解析失败，降级使用服务端 preview:', e.message)
      }
    },
    readFileAsText (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(new Error('读取文件失败'))
        reader.readAsText(file, 'UTF-8')
      })
    },
    parseCSVRows (text) {
      // 去掉 BOM
      const content = text.replace(/^﻿/, '')
      const lines = content.split(/\r?\n/).filter(l => l.trim())
      if (lines.length < 2) return []
      const headers = this.parseCSVLine(lines[0])
      const rows = []
      for (let i = 1; i < lines.length; i++) {
        const vals = this.parseCSVLine(lines[i])
        if (!vals.some(v => v !== '')) continue // 跳过全空行
        const row = {}
        headers.forEach((h, j) => { row[h] = (vals[j] || '').trim() })
        rows.push(row)
      }
      return rows
    },
    parseCSVLine (line) {
      const result = []
      let current = ''
      let inQuotes = false
      for (const ch of line) {
        if (inQuotes) {
          if (ch === '"') inQuotes = false
          else current += ch
        } else {
          if (ch === '"') inQuotes = true
          else if (ch === ',') { result.push(current.trim()); current = '' } else current += ch
        }
      }
      result.push(current.trim())
      return result
    }
  }
}
